// extracted by mini-css-extract-plugin
export default {"nearbyLink":"_295OMbmj","icon":"_2SARomzO","text":"_3QAE6J7j"};